export const TOP_MESSAGE_LENGTH = 15;
export const LOWER_MESSAGE_LENGTH = 12;
